import GameBanner from "../components/banner"
import GameNavigation from "../components/navigator"
import {GameTab} from "../components/game/tab"
export const GameHomeScreen = () => {
    return (
        <>
            <GameNavigation />
            <GameBanner />

            <GameTab />
        </>
    )
}